export let settings = {
  columns: {
    name: {
      title: 'Nom',
      filter: false
    }
  },
  edit: {
    editButtonContent: '<i class="ti-pencil text-info m-r-10"></i>',
    saveButtonContent: '<i class="ti-save text-success m-r-10"></i>',
    cancelButtonContent: '<i class="ti-close text-danger"></i>'
  },
  delete: {
    deleteButtonContent: '<i class="ti-trash text-danger m-r-10"></i>',
    saveButtonContent: '<i class="ti-save text-success m-r-10"></i>',
    cancelButtonContent: '<i class="ti-close text-danger"></i>',
    confirmDelete : true
  },
  add : {
    createButtonContent:"Créer",
    cancelButtonContent:"Annuler",
    addButtonContent:"Nouveau"
  }
};

export let data = [
  {
    id: 1,
    name: 'Séquence 1'
  },
  {
    id: 2,
    name: 'Séquence 2'
  },
  {
    id: 3,
    name: 'Séquence 3'
  },
  {
    id: 4,
    name: 'Séequence 4'
  },
  {
    id: 5,
    name: 'Sequence 5 et 6'
  }
];
